"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSurveyMarketRequestToJSON = exports.GetSurveyMarketRequestFromJSONTyped = exports.GetSurveyMarketRequestFromJSON = exports.instanceOfGetSurveyMarketRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the GetSurveyMarketRequest interface.
 */
function instanceOfGetSurveyMarketRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetSurveyMarketRequest = instanceOfGetSurveyMarketRequest;
function GetSurveyMarketRequestFromJSON(json) {
    return GetSurveyMarketRequestFromJSONTyped(json, false);
}
exports.GetSurveyMarketRequestFromJSON = GetSurveyMarketRequestFromJSON;
function GetSurveyMarketRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'experimentId': !(0, runtime_1.exists)(json, 'experiment_id') ? undefined : json['experiment_id'],
        'market': !(0, runtime_1.exists)(json, 'market') ? undefined : json['market'],
    };
}
exports.GetSurveyMarketRequestFromJSONTyped = GetSurveyMarketRequestFromJSONTyped;
function GetSurveyMarketRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'experiment_id': value.experimentId,
        'market': value.market,
    };
}
exports.GetSurveyMarketRequestToJSON = GetSurveyMarketRequestToJSON;
